import React from 'react'
import Header from './../Header/Header'
import Footer from './../Footer/Footer'
import { Link } from 'react-router-dom'

function PrivacyPolicy() {
    return (
        <>
            <Header />

            <div className="container-fluid py-5">
                <div className="container-lg">
                    <div className="row">
                        <ul>

                            <div className="privacy-policy">
                                <li>Privacy Policy:</li>
                                <p>
                                    At Waywys, accessible from
                                    <Link to="https://waywys.in/">https://waywys.in/</Link>,
                                    protecting the privacy of our visitors and users is one of our main priorities.
                                    This Privacy Policy explains what information we collect, how we use it,
                                    and how we safeguard your data.
                                </p>

                                <p>
                                    If you have additional questions or require more information about our Privacy Policy,
                                    feel free to contact us.
                                </p>

                                <p>
                                    This Privacy Policy applies only to online activities and is valid for visitors to our website
                                    with regard to the information they share and/or collect on Waywys.
                                    This policy does not apply to information collected offline or through channels
                                    other than this website.
                                </p>
                            </div>

                            <div className="privacy-policy">
                                <li>Consent</li>
                                <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>
                            </div>

                            <div className="privacy-policy">
                                <li>Information We Collect</li>
                                <p>
                                    The personal information you are asked to provide—and the reasons for requesting it—will be explained
                                    at the point we ask you to provide your information.
                                </p>
                                <p>
                                    If you contact us directly, we may receive additional information about you such as your name,
                                    email address, phone number, message content, and any attachments you may send.
                                </p>
                                <p>
                                    When you register for an account or submit a form, we may request details such as your name,
                                    company name, address, email, and telephone number.
                                </p>
                            </div>

                            <div className="privacy-policy">
                                <li>How We Use Your Information</li>
                                <p>We use the information we collect in various ways, including to:</p>
                            </div>

                            <div className="privacy-policy-list">
                                <ul style={{ listStyleType: "disc" }}>
                                    <li>Provide, operate, and maintain our website</li>
                                    <li>Improve, personalize, and expand our website</li>
                                    <li>Understand and analyze how you use our website</li>
                                    <li>Develop new products, services, features, and functionality</li>
                                    <li>Communicate with you for customer service, updates, and marketing</li>
                                    <li>Send you emails</li>
                                    <li>Identify and prevent fraud</li>
                                </ul>
                            </div>

                            <div className="privacy-policy">
                                <li>Log Files</li>
                                <p>
                                    Waywys follows a standard procedure of using log files. These files record visitors when they visit
                                    websites—a common practice for hosting companies. The data collected includes IP addresses, browser
                                    type, ISP, date/time stamps, referring/exit pages, and number of clicks. This information is not
                                    personally identifiable and is used for analytics, site administration, and user behavior tracking.
                                </p>
                            </div>

                            <div className="privacy-policy">
                                <li>Advertising Partners Privacy Policies</li>
                                <p>
                                    Third-party advertisers on Waywys may use cookies, JavaScript, or web beacons in their advertisements.
                                    When this happens, your IP address is automatically collected. These technologies measure ad performance
                                    and personalize ad content.
                                    Waywys does not control these third-party cookies.
                                </p>
                            </div>

                            <div className="privacy-policy">
                                <li>Third-Party Privacy Policies</li>
                                <p>
                                    Waywys' Privacy Policy does not apply to other advertisers or websites.
                                    We recommend reviewing the privacy policies of third-party ad servers for more details on their practices.
                                </p>
                                <p>
                                    You may disable cookies through your browser settings. To learn more about cookie management,
                                    check your browser's official website.
                                </p>
                            </div>

                            <div className="privacy-policy">
                                <li>CCPA Privacy Rights (Do Not Sell My Personal Information)</li>
                                <p>Under the CCPA, California consumers have the right to:</p>
                                <p>Request disclosure of what personal data a business collects about them.</p>
                                <p>Request deletion of personal data collected.</p>
                                <p>Request that a business does not sell their personal data.</p>
                                <p>
                                    If you make a request, we have one month to respond.
                                    To exercise any of these rights, please contact us.
                                </p>
                            </div>

                            <div className="privacy-policy">
                                <li>Children's Information</li>
                                <p>
                                    Protecting children while using the internet is important to us.
                                    Waywys does not knowingly collect personal information from children under 13.
                                    If you believe your child has shared such information, please contact us immediately—
                                    we will promptly remove it from our records.
                                </p>
                            </div>

                            <div className="privacy-policy">
                                <li>Contact Us</li>
                                <p>If you have any questions about our Privacy Policy, please contact us:</p>
                                <p><strong>Phone:</strong> 9729170195</p>
                                <p><strong>Email:</strong> waywys.it@gmail.com</p>
                            </div>

                        </ul>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default PrivacyPolicy